import { Trans } from '@lingui/react'
import classNames from 'clsx'

import Image from 'views/components/atoms/Image'
import ButtonAsLink from 'views/components/molecules/ButtonAsLink'
import nowLogoRebrandingCOM from 'views/components/organisms/Cart/NowCollapsible/now_logo_rebranding_com.png'
import { NOW_SHIPPING_CART_MODAL_ID } from 'views/components/organisms/NowShippingModal/names'
import { OPEN_NOW_CART_SHIPPING_MODAL } from 'views/containers/browser/NowShippingModalCartContainer/clientsideHook'

import './NowNeutralCaseBox.scss'

interface NowNeturalCaseProps {
  hasNowEligilityCheck?: boolean
}

const NowNeutralCaseBox = ({ hasNowEligilityCheck }: NowNeturalCaseProps) => {
  return (
    <section
      data-qa-id={'now-neutral-case-box'}
      className={classNames('m-NowNeutralCaseBox__container', {
        'm-NowNeutralCaseBox__container--has-no-button': !hasNowEligilityCheck,
      })}
    >
      <Image
        src={nowLogoRebrandingCOM}
        alt="NOW logo"
        className={classNames('m-NowNeutralCaseBox__logo', {
          'm-NowNeutralCaseBox__logo--small': !hasNowEligilityCheck,
          'm-NowNeutralCaseBox__logo--large': hasNowEligilityCheck,
        })}
      />
      <article className={'m-NowNeutralCaseBox__article'}>
        <p>
          <Trans id={'general.label.now.enterZipCodeInfoText'} />
        </p>
        {hasNowEligilityCheck && (
          <ButtonAsLink
            id={'check-now-eligibility-button'}
            bold
            data-clientside-hook={OPEN_NOW_CART_SHIPPING_MODAL}
            data-a11y-dialog-show={NOW_SHIPPING_CART_MODAL_ID}
          >
            <Trans id={'general.label.now.checkNowEligibilityButton'} />
          </ButtonAsLink>
        )}
      </article>
    </section>
  )
}

export default NowNeutralCaseBox
